import { getDataFromApiAction } from '../../components/Atoms/GraasApiUtility/GraasApiUtility.action';
import { apiServices } from '../../redux/utils/api_services';
import { nanoid } from 'nanoid';
import { message } from 'antd';
import { map as _map, isEmpty as _isEmpty, forEach as _forEach, filter as _filter } from 'lodash-es';
import { onCreateChannelSpecificDashboard } from 'redux/CustomDashboard/CustomDashboard.action';
import { onCreateECommerceDashboard } from 'redux/WorkSpace/WorkSpace.action';

export const getAvailableSourceOrderStatusFromQuery = async (channelName, t) => {
  try {
    const url = `${apiServices['sphere']}/data/validOrderStatus?channel=${channelName}`;
    const response = await getDataFromApiAction(url, {});
    return response?.data || [];
  } catch (error) {
    message.error(t('GRAAS_FAIL_TO_GET_ORDER_STATUS_LIST_GRAAS'));
    return [];
  }
};

export const arraysAreEqual = async (arr1, arr2) => {
  try {
    if (arr1.length !== arr2.length) return false;

    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    return sortedArr1.every((value, index) => value === sortedArr2[index]);
  } catch (error) {
    return false;
  }
};

// This function extracts the channel name from the URL in the '/connect/{channelName}' format.
// Example: For the URL 'http://domain.com/connect/shopify?param=value', it returns 'shopify'.
export const getChannelNameInURL = () => {
  const currentURL = window.location.href; // Get the full current URL
  const mainPart = currentURL.split('?')[0]; // Remove query parameters by splitting at '?'
  const connectSegment = mainPart.split('/connect/')[1]; // Extract the part after '/connect/'
  return connectSegment ? connectSegment.split('/')[0] : null; // Return the channel name or null if not found
};

export const getFilterMappingList = mappingSet => {
  let groupByMetricTypeObj = {};
  let metricTypeArray = [];
  if (mappingSet?.list && mappingSet?.list.length > 0) {
    _map(mappingSet?.list, mappintList => {
      if (mappintList?.eq_category_priority !== 0 && mappintList?.applications_in_use.includes('Chart Builder')) {
        let metricType = mappintList?.metric_group || 'Unknown';
        let groupMetricList = groupByMetricTypeObj?.[metricType] || [];
        groupMetricList?.push(mappintList);
        metricTypeArray?.push(metricType);
        groupByMetricTypeObj[metricType] = groupMetricList;
      }
    });
  }
  return groupByMetricTypeObj;
};

// TC-16541
// After a channel is successfully connected, we need to create a dashboard
// based on the countryWiseDashboardCreation mapping.
// This logic is applicable for country-specific configurations.
// The checkAndCreateDashboard function handles the dashboard creation.
// Note: If a new channel needs to be added, make sure to update the visualization config as well.
const countryWiseDashboardCreation = {
  IN: ['shopify', 'amazon', 'amazonAds']
};

export const checkAndCreateDashboard = async (dispatch, countryCode, channel) => {
  try {
    if (countryWiseDashboardCreation?.[countryCode]?.includes(channel)) {
      const url = `${apiServices['chart']}/custom-dashboard/?trace_id=${nanoid()}&path=${location.pathname}${
        location.search
      }`;
      const apiResponse = await getDataFromApiAction(url);
      if (_isEmpty(apiResponse?.data)) {
        let default_configs = apiResponse?.default_configs || [];
        if (!_isEmpty(default_configs)) {
          if (['US', 'IN'].includes(countryCode)) {
            _forEach(default_configs, dashboard => {
              if (dashboard.code === 'combined-ws') {
                dashboard.is_default = true;
              } else {
                dashboard.is_default = false;
              }
            });
          }
          dispatch(
            onCreateECommerceDashboard({
              trace_id: nanoid(),
              path: location.pathname + location.search,
              otherDashboards: default_configs
            })
          );
        }
      }
      dispatch(onCreateChannelSpecificDashboard({ channel: [channel] }));
    }
  } catch (error) {
    console.error('Default Dashboard Creation Failed');
  }
};

export const getDataAccuracySupportedChannels = nickNameList => {
  return _filter(nickNameList, nickname => dataAccuracySupportedChannel?.includes(nickname?.split('-')?.[0]));
};

export const dataAccuracySupportedChannel = ['lazada', 'shopee', 'tokopedia', 'amazon'];
